import ButtonNew from "components/atoms/ButtonNew/index";
import Img from "components/atoms/Img";
import Title from "components/atoms/Title";

export default function ScreenStart({ setStartScreen }) {
  return (
    <>
      <section>
        <div className="row">
          <div className="col-12 lg:col-6">
            <h1 className="bg-[linear-gradient(89.75deg,#BA3838_-4.9%,#FF0000_97.56%)] bg-clip-text text-center text-2xl font-semibold leading-9 tracking-[0.25px] text-transparent lg:text-left lg:text-bbc-48px ">
              BELIZE
            </h1>
            <Title
              text="Tax Status Assessment"
              className="mb-4 bg-[linear-gradient(89.75deg,#3838BA_-4.9%,#00A3FF_97.56%)] bg-clip-text text-center text-2xl font-semibold leading-9 text-transparent lg:mb-6 lg:text-left lg:text-bbc-40px"
            />
            <p className="mb-10 lg:mb-12">
              Taxation is always a foremost concern when it comes to starting
              your business overseas. Try this self-assessment test now to check
              whether your entity is taxable in Belize. And find out what your
              compliance obligations can be.
            </p>
            <div className="hidden lg:block">
              <ButtonNew
                className={
                  "inline-block rounded-full bg-bbc-brand-500 px-6 py-2 font-semibold leading-[26px]  tracking-[0.4px] text-white transition-all duration-200 hover:bg-bbc-brand-600 lg:font-medium "
                }
                onClick={() => setStartScreen(false)}
              >
                Start Now
              </ButtonNew>
            </div>
          </div>
          <div className="col-12 mb-10 text-center lg:col-6 lg:mb-0 lg:text-left">
            <Img
              src="assets/images/offshore/belize-mini-tool/mini_tool-belize.png"
              alt="belize-mini-tool"
              width={540}
              height={440}
            />
          </div>
          <div className="block text-center lg:hidden">
            <ButtonNew onClick={() => setStartScreen(false)}>
              Start Now
            </ButtonNew>
          </div>
        </div>
      </section>
      <section>
        <div>
          <div className="rounded-[20px] bg-transparent p-0 lg:bg-white lg:p-10">
            <p className="mb-4 font-medium text-bbc-brand-700">Disclaimer:</p>
            <p>
              The information contained in this tool is for general information
              purposes only. You should not substitute the information provided
              in this tool for competent legal advice. For further in-depth
              understanding of how your entity may be taxed in Belize, please
              engage professional advice.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
